import LandlordReviewPage from './LandlordReviewPage';

export default LandlordReviewPage;
